import React from 'react';
import {updateObject, isMobile} from './Utils';

const ContextGlobal = React.createContext();

function GlobalReducer(state, action){
  switch(action.type){
    case "UpdateSound":
      return updateObject(state, {sound: !state.sound});
  
    case "UpdateConfig":
      return updateObject(state, {config: !state.config});

    case "UpdateIsMobile":
      return updateObject(state, action);

    default: {
      return state;
    }
  }
}

function GlobalProvider({children}){
  const [state, dispatch] = React.useReducer(GlobalReducer, {sound: false, config: false, isMobile: isMobile()});

  return (
      <ContextGlobal.Provider value={{state, dispatch}}>
        {children}
      </ContextGlobal.Provider>
  );
}

export {GlobalProvider, ContextGlobal};
